import logo from '../../assets/images/OrcheXtra_logo.svg';
import { HERO_IMG, NAVY } from '../../utils/constants';
import BreadCrumbComponent, { BreadcrumbLinkData } from '../../utils/BreadCrumbComponent';

interface HeroSectionProps {
  title: string;
  description: string;
  action?: React.ReactNode;
  height?: string;
  breadcrumbLinks?: BreadcrumbLinkData[];
}

const HeroSection = ({ title, description, action, height = '360px', breadcrumbLinks }: HeroSectionProps) => {
  return (
    <div className="relative overflow-hidden flex-shrink-0" style={{ height }}>
      <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div
        className="absolute inset-0"
        style={{ background: `linear-gradient(to right, ${NAVY}eb, ${NAVY}a6)` }}
      />

      <div className="relative z-10 h-full flex flex-col px-8 lg:px-16">
        {breadcrumbLinks && (
          <div className="pt-4">
            <BreadCrumbComponent links={breadcrumbLinks} white />
          </div>
        )}

        <div className="flex flex-1 items-center gap-8">
          <div className="flex flex-col flex-1">
            <div className="flex items-center gap-3 mb-5">
              <img
                src={logo}
                alt="OrcheXtra"
                className="h-8 object-contain"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </div>
            <h1 className="text-white text-4xl lg:text-5xl font-bold leading-tight mb-4 font-heading">
              {title}
            </h1>
            <p className="text-white/80 text-lg max-w-2xl leading-relaxed font-paragraph">
              {description}
            </p>
          </div>

          {action && (
            <div className="flex-shrink-0">
              {action}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
